<template>

	<div class="form-layout">

		<div class="primary">
			<slot name="form" />
		</div>

		<div class="secondary" v-if="!$store.state.app.embedMode">
			<slot name="info" />
		</div>

	</div>

</template>

<script>
	export default {
		name: "formLayout"
	};
</script>

<style lang="scss" scoped>

	@import "media";
	@import "container";

	.form-layout {
		@include media(small,xlarge) {
			@include container;
			& > * {
				padding-top:4rem;
			}
		}

		@include media(xlarge) {
			display:flex; flex-direction:row-reverse; align-items:left; margin-left:-2px;
			& > * {
				padding:6em; margin-left:2px;
			}
			.primary {
				flex-grow:1;
			}
			.secondary {
				flex-basis:percentage(1/3);
			}
		}

	}

	body.embed-mode {
		.form-layout {
			.primary {
				padding-top:0 !important; padding-bottom:0 !important;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/layouts/FormLayout.vue